import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import CustomThemeProvider from './styles/ThemeContext';
import { LoginForm } from './components/auth/LoginForm';
import { PrivateRoute } from './components/auth/PrivateRoute';
import Dashboard from './components/Dashboard';
import Loader from './components/shared/Loader';
import NotificationProvider from './components/shared/NotificationSystem';
import ReduxLanguageProvider from './i18n/ReduxLanguageProvider';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import { clearCacheOnReload } from './utils/cacheUtils';

const App: React.FC = () => {
    // Очищаем временный кеш при первой загрузке/перезагрузке приложения
    useEffect(() => {
        clearCacheOnReload();
    }, []);

    return (
        <Provider store={store}>
            <ReduxLanguageProvider>
                <AuthProvider>
                    <CustomThemeProvider>
                        <NotificationProvider>
                            <Router>
                                <Routes>
                                    <Route path="/" element={<RootRedirect />} />
                                    <Route path="/login" element={<LoginForm />} />
                                    <Route
                                        path="/*"
                                        element={
                                            <PrivateRoute>
                                                <Dashboard />
                                            </PrivateRoute>
                                        }
                                    />
                                </Routes>
                            </Router>
                        </NotificationProvider>
                    </CustomThemeProvider>
                </AuthProvider>
            </ReduxLanguageProvider>
        </Provider>
    );
};


const RootRedirect: React.FC = () => {
    const { authenticated, loading } = useAuth();

    // Если проверка не завершена, показываем индикатор загрузки
    if (loading) {
        return <Loader />;
    }

    // Если пользователь авторизован, перенаправляем на контент
    // Иначе перенаправляем на страницу входа
    return authenticated ?
        <Navigate to="/content" replace /> :
        <Navigate to="/login" replace />;
};

export default App;